export const validEmail = (email: string): boolean => {
  return !!email.match(/(^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$)/g);
};
